import { render, staticRenderFns } from "./tablePie.vue?vue&type=template&id=832d69b2&scoped=true&"
import script from "./tablePie.vue?vue&type=script&lang=ts&"
export * from "./tablePie.vue?vue&type=script&lang=ts&"
import style0 from "./tablePie.vue?vue&type=style&index=0&id=832d69b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "832d69b2",
  null
  
)

export default component.exports